<template>
    <div v-if="hasErrors" class="ui-validation-errors" dusk="validation">
        <div v-if="headingText" class="ui-validation-errors__heading">{{ headingText }}</div>

        <ul class="ui-validation-errors__list">
            <li v-for="(error, key) in flatErrors" :key="key" class="ui-validation-errors__item">
                {{ error }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { lang } from '@/lang/composable';

const props = defineProps<{
    errors?: string[] | Record<string, string | string[]>;
    heading?: string;
}>();

const page = usePage();

const headingText = computed(() => {
    if (props.heading !== undefined) {
        return props.heading || null;
    }
    return props.errors === undefined ? lang('general.failed') : null;
});

const sourceErrors = computed(() => props.errors ?? page.props.errors);

const hasErrors = computed(() => {
    if (Array.isArray(sourceErrors.value)) {
        return sourceErrors.value.length > 0;
    }
    return sourceErrors.value && Object.keys(sourceErrors.value).length > 0;
});

const flatErrors = computed(() => {
    if (Array.isArray(sourceErrors.value)) {
        return sourceErrors.value;
    }
    return Object.values(sourceErrors.value).reduce<string[]>((acc, error) => {
        if (typeof error === 'string') {
            acc.push(error);
        } else {
            acc = acc.concat(Object.values(error as Record<string, string>));
        }
        return acc;
    }, []);
});
</script>
